import React, { Fragment } from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import HmAjax from '../../util/HmAjax';
import HmEventRegistry from '../../model/HmEventRegistry';
import ProductConfig from '../../../src/config/ProductConfig.json';

// ES6 class-style
class Hm_Footer extends PreLoginPage {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		//console.warn("SG Footer");
		const { products, self, plp } = this.state;

	}

	componentDidUpdate() {
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	}

	onClickDemoFn = () => {
		if (typeof this.props.demoFn === "function") {
			this.props.demoFn();
		}
	}

	//   getDemoFn = () =>{
	// 	return(
	// 		<div className='col-md-12 mb-10 demobtn'>		
	// 			<span data-ga="Homework - Demo button" onClick={this.onClickDemoFn} className="r-btn contactbtn">{this.rb("homework.demo")}</span>		  					  		
	// 			  </div>
	// 	)
	// }


	render() {
		let telPhoneNo = window.telPhoneNo[this.getGeo()] || window.telPhoneNo['OTHERS'] || '+91 44 3500 2073';

		return (
			<footer>
				<div className="container homework-footer">
					<div className="row grade-links">
						<div className="col-12 col-md-4">
							{/* <ul className="f-links atag">

  			<li data-ga="Footer - Home" ><Link to="/">Home</Link></li>
			  {this.SgCatalogue()}
			  
			 <li data-ga="Footer - Who we are" ><Link to="/who-we-are">Who We Are</Link></li>
			 <li data-ga="Footer - Our Learnings"><Link to="/our-learnings">Our Learnings</Link></li> 
			<li data-ga="Footer - Spotlight" ><Link to="/spotlight">Spotlight</Link></li>
			<li data-ga="Footer - FAQ" ><Link to="/faq">{this.rb("FAQ")}</Link></li>
  		</ul> */}
						</div>

					</div>
					<div className="row follow-us">
						<div className="col-lg-4 col-md-5 no-padding">
							<div className="follow">
								<p>Follow us on</p>
								<ul>
									<li><a data-ga="Footer - Follow Us - Facebook" href="https://www.facebook.com/heymath" target="_blank"><i className="fab fa-facebook-f"></i></a></li>
									{/* <li><a data-ga="Footer - Follow Us - Twitter" href="http://twitter.com/heymath" target="_blank"><i className="fab fa-twitter"></i></a></li> */}
									<li><a data-ga="Footer - Follow Us - Linkedin" href="http://linkedin.com/company/heymath" target="_blank"><i className="fab fa-linkedin-in"></i></a></li>
									<li><a data-ga="Footer - Follow Us - Youtube" href="http://bit.ly/HeyMathYouTube" target="_blank"><i className="fab fa-youtube"></i></a></li>
									<li><a data-ga="Footer - Follow Us - Instagram" href="https://www.instagram.com/heymath_india/" target="_blank"><i className="fab fa-instagram"></i></a></li>
								</ul>
							</div>
						</div>
						<div className="col-lg-4 col-md norightpadding">
							<div className="text-link text-left">
								<a data-ga="Footer - Phone number" href={"tel:" + telPhoneNo}><img src="../img/tel.png" alt="" /> {telPhoneNo}</a>
							</div>
							<div className="text-link text-left">
								<a data-ga="Footer - Email ID" href="mailto:support@heymath.com"><img src="../img/mail.png" alt="" /> support@heymath.com</a>
							</div>
						</div>
						<div className="col-lg-4 col-md nopadding">
							<div className="text-link text-center">
								<span data-ga="Footer - Homework - Likedemo" className="r-btn contactbtn" onClick={this.onClickDemoFn}>{this.rb("homework.demo")}</span>
							</div>
						</div>
					</div>
					<div className="row copyrights">
						<div className="col-md-4 text-link ">
							<p className="text-left">All rights reserved &copy; {this.rb("footer.copyright.year")} <strong>HeyMath!</strong> </p>
						</div>
						<div className="col-md-4 text-link">
							<a data-ga="Footer - Terms" href={this.getTermsUrl("IN")} target="_blank"> Terms of Use</a>
							<span>|</span> <a data-ga="Footer - Privacy Policy" href={this.getUrlFor("LUMOS_PRIVACY")} target="_blank"> Privacy Policy</a>
						</div>
						<div className="col-md-4 text-link">
							{/* <div className="logo"><Link to="/"> <img src="/img/h-logo.png" alt="heymath logo"/></Link></div> */}
							{/* <p>Designed by <a data-ga="Footer - Leo9" href="http://www.leo9studio.com/" target="_blank"><strong>Leo9 Studio</strong></a></p> */}
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default Hm_Footer;



// WEBPACK FOOTER //
// ./src/vendors/homework/Hm_Footer.js